






















































































import { Component, Provide, ProvideReactive, Vue } from 'vue-property-decorator'
import { v4 as uuid } from 'uuid'
import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { RealworksStatusRuleAPI, RealworksKenmerkAPI } from '@/api/backend-client'
import { ReferralStatus } from '@/api/types'
import { InputSelectOption } from '@/helpers/options'
import { escapeHtml } from '@/helpers/html'

@Component
export default class CreatePhaseStatusPopout extends Vue {
    visible: boolean = false
    saving: boolean = false
    currentStep: number = 1
    realworksStatusRule: RealworksStatusRule = null
    realworksStatusRuleExists: boolean = false
    @ProvideReactive() loadingKenmerken: boolean = true
    @ProvideReactive() kenmerken: InputSelectOption[] = []

    async open() {
        this.realworksStatusRule = RealworksStatusRule.fromData( {
            id: uuid(),
            company: this.$currentCompany,
            toStatus: ReferralStatus.OPEN,
            assignToMedewerker: false,
            notifyAssignedTo: true,
            comment: '',
            active: true,
            applyToTriggeredReferrals: true,
            applyToTriggeredReferralsPastDays: 2,
        })
        this.realworksStatusRuleExists = false
        this.reload()
        this.currentStep = 1
        this.visible = true
    }

    async openWithExisting(realworksStatusRule: RealworksStatusRule) {
        this.realworksStatusRule = await RealworksStatusRuleAPI.get(realworksStatusRule.id, true)
        this.realworksStatusRuleExists = true
        this.reload()
        this.currentStep = 1
        this.visible = true
    }

    close() {
        this.visible = false
    }

    async save(): Promise<void> {
        try {
            this.saving = true
            if (!this.realworksStatusRuleExists) {
                await RealworksStatusRuleAPI.create(this.realworksStatusRule)
            } else {
                await RealworksStatusRuleAPI.update(this.realworksStatusRule.id, this.realworksStatusRule)
            }
            this.$emit('save')
            this.close()
        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })
        } finally {
            this.saving = false
        }
    }

    previousStep(): void {
        this.currentStep--
    }

    nextStep(): void {
        if (this.currentStep <= 3) {
            this.currentStep++
        }
    }

    async reload(): Promise<void> {
        this.loadKenmerken()
    }

    async loadKenmerken() {
        this.loadingKenmerken = true

        const kenmerken = await RealworksKenmerkAPI.getAll()
        this.kenmerken = kenmerken
            .map(kenmerk => ({
                label: kenmerk.omschrijving,
                value: kenmerk.id.toString(), // cast to string because API expects a string
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

        this.loadingKenmerken = false
    }

    @Provide()
    kenmerkLabel(kenmerkId: string): string {
        const kenmerk = this.kenmerken.find(kenmerkOption => kenmerkOption.value === kenmerkId)
        if (kenmerk) {
            return kenmerk.label
        }

        return kenmerkId
    }
}
